export default {
    parts: [
        'trigger',
        'triggerText',
        'label',
        'labelFloated',
        'dropdown',
        'option',
        'optionText',
        'checkIcon',
        'chevron',
        'errorMessage',
        'helperText'
    ],
    baseStyle: (props) => ({
        trigger: {
            height: '48px',
            width: '100%',
            textAlign: 'left',
            position: 'relative',
            paddingLeft: 2,
            paddingRight: '36px',
            paddingTop: '22px',
            paddingBottom: '4px',
            borderRadius: 0,
            display: 'flex',
            alignItems: 'center',
            bg: 'webTheme.fieldDefault',
            border: '1px solid',
            borderColor: 'webTheme.strokeSecondary',
            color: 'webTypo.textPrimary',
            cursor: 'pointer',
            _focus: {outline: 'none', boxShadow: 'none'},
            _focusVisible: {outline: 'none', boxShadow: 'none'},
            _invalid: {borderColor: 'webTheme.strokeWarning'},
            _disabled: {
                bg: 'webTheme.fieldDisabled',
                borderColor: 'webTypo.textDisabled',
                color: 'webTypo.textDisabled',
                cursor: 'not-allowed'
            }
        },
        triggerText: {
            textStyle: 'bodyMdRegular',
            flex: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        label: {
            ...(props?.theme?.textStyles?.bodySmRegular || {}),
            position: 'absolute',
            left: '9px',
            top: '14px',
            zIndex: 2,
            mb: 0,
            pointerEvents: 'none',
            transformOrigin: 'left top',
            transition: 'all 0.15s ease-in-out',
            color: 'webTypo.textSecondary',
            '.web-field-suffix': {color: 'webTypo.textSecondary'},
            '.web-field-optional': {color: 'webTypo.textSecondary'}
        },
        labelFloated: {
            ...(props?.theme?.textStyles?.bodyXsRegular || {}),
            top: '4px',
            color: 'webTypo.textSecondary'
        },
        dropdown: {
            position: 'absolute',
            left: 0,
            right: 0,
            top: '49px',
            bg: 'white',
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            zIndex: 20,
            maxH: '240px',
            overflowY: 'auto',
            boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.1)',
            '&::-webkit-scrollbar': {width: '5px'},
            '&::-webkit-scrollbar-button': {display: 'none'},
            '&::-webkit-scrollbar-thumb': {bg: 'webTheme.strokeSecondary', borderRadius: 'full'},
            '&::-webkit-scrollbar-track': {bg: 'transparent', borderRadius: 'full'}
        },
        option: {
            px: 2,
            py: '12px',
            minH: '48px',
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            _last: {borderBottom: 0},
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            _hover: {bg: 'webTheme.fieldHover'},
            _selected: {bg: 'webTheme.fieldDefault'}
        },
        optionText: {
            ...(props?.theme?.textStyles?.bodySmRegular || {}),
            color: 'webTypo.textPrimary'
        },
        checkIcon: {
            w: '24px',
            h: '24px',
            flexShrink: 0,
            color: 'webTypo.textPrimary'
        },
        chevron: {
            position: 'absolute',
            right: '14px',
            top: '50%',
            w: '16px',
            h: '16px',
            pointerEvents: 'none'
        },
        errorMessage: {
            ...(props?.theme?.textStyles?.bodyXsRegular || {}),
            color: 'webTypo.textError',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        },
        helperText: {
            ...(props?.theme?.textStyles?.bodyXsRegular || {}),
            mt: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            color: 'webTypo.textSecondary'
        }
    })
}
